import React from 'react'

const RunRoute: React.FC = () => {
    return (
        <div className="flex flex-col md:flex-row">
            {/* Text Side */}
            <div className="w-full md:w-1/2 flex items-center justify-center bg-cyan-100 text-black p-8">
                <div className="max-w-xl flex flex-col gap-6">
                    <h2 className="text-4xl md:text-6xl font-bold">10k Event Information</h2>
                    <ul className="list-disc list-inside space-y-2 text-lg">
                        <li>Minimum entry age is 15 years</li>
                        <li>
                            The route is undulating and a single loop course, which starts and
                            finishes at Kilverts Field
                        </li>
                        <li>
                            The route will be clearly marked at every kilometre, and marshals will
                            support and encourage every participant to the finish line
                        </li>
                        <li>
                            The run will take place on the road and the pavements
                        </li>
                        <li>
                            All participants are advised to only cross the roads where the marshals
                            are positioned
                        </li>
                        <li>
                            A water station will be available on the route, and refreshments will be
                            provided at the finish line
                        </li>
                        <li>The event will be chip timed and photographed</li>
                        <li>
                            There is a unique medal for every participant who crosses the finish
                            line, and trophies for category winners
                        </li>
                        <li>
                            Participants are strongly advised not to wear headphones, but if they
                            choose to do so it is at the participant&apos;s own risk
                        </li>
                        <li>
                            Decisions for refunds, deferrals and transfers will be made by the event
                            organiser, and all enquiries must be directed to{' '}
                            <a
                                href="mailto:graysrun@outlook.com"
                                className="font-medium text-blue-700 hover:underline">
                                graysrun@outlook.com
                            </a>
                            .
                        </li>
                    </ul>
                </div>
            </div>

            {/* Image Side */}
            <div className="w-full md:w-1/2 flex items-center justify-center bg-cyan-100 p-8">
                <img
                    src="/assets/run-route-screenshot.png"
                    alt="Map"
                    className="w-full h-auto max-h-[80vh] object-contain"
                />
            </div>
        </div>
    )
}

export default RunRoute
